export default __webpack_public_path__ + "static/media/AI-pos.4157471b.svg";